import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events, AlertController, ModalController, Alert, MenuController, PopoverController, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';


import { PaginaprincipalPage } from '../pages/paginaprincipal/paginaprincipal';
import { GlobalProvider } from '../providers/global/global';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { BehaviorSubject } from 'rxjs';
import { SQLiteObject, SQLite } from '@ionic-native/sqlite';
import { TranslateService } from '@ngx-translate/core';
import { Network } from '@ionic-native/network';
import { CongresosProvider } from '../providers/congresos/congresos';
import { LoginProvider } from '../providers/login/login';
import { ImagenesProvider } from '../providers/imagenes/imagenes';
import { CongresoPage } from '../pages/congreso/congreso';
import { PonentesPage } from '../pages/ponentes/ponentes';
import { ProgramaPage } from '../pages/programa/programa';
import { DocumentosPage } from '../pages/documentos/documentos';
import { LinksPage } from '../pages/links/links';
import { EncuestaPage } from '../pages/encuesta/encuesta';
import { NotificacionesPage } from '../pages/notificaciones/notificaciones';
import { PatrocinadoresPage } from '../pages/patrocinadores/patrocinadores';
import { PreguntasPage } from '../pages/preguntas/preguntas';
import { ProgramaProvider } from '../providers/programa/programa';
//import { PonentesProvider } from '../providers/ponentes/ponentes';
//import { CongresoEditPage } from '../pages/congreso-edit/congreso-edit';
import { PresentacionEditPage } from '../pages/presentacion-edit/presentacion-edit';
import { PanelPage } from '../pages/panel/panel';
import { MenuProvider } from '../providers/menu/menu';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { NotificacionesProvider } from '../providers/notificaciones/notificaciones';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { PonentesProvider } from '../providers/ponentes/ponentes';
import { AsistentesProvider } from '../providers/asistentes/asistentes';
import { ChatProvider } from '../providers/chat/chat';
import { PatrocinadoresProvider } from '../providers/patrocinadores/patrocinadores';
//import { errorHandler } from '@angular/platform-browser/src/browser';
declare var window: any;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  //--------------------------------------
  // BACK OFFICE
  //rootPage:any = 'page-login';

  // APP
  // rootPage: any = 'page-home';
  //--------------------------------------
  rootPage: any = "";
  public db: any;
  public isChrome;
  public isSafari;
  selectedTheme: String;
  public oculta_screen;
  public esbackoffice;
  public usuario_registrado;
  private database: SQLiteObject;
  private dbReady = new BehaviorSubject<boolean>(false);
  public login_reg: { email?: '', password?: '' } = {}
  public guidr;
  //public listamenu;
  public misponentes = [];
  public miprograma = [];
  public guardado;
  public menuguardado;
  public patrocinadorguardado;
  public tipo;
  selectedMenu: any;
  public congreso_desplegado = 0;
  //public usuario_desplegado = 1;
  public datos_desplegado = 0;
  public asistente_formateado: {
    clave?: '', nombre?: '', empresa?: '', cargo?: '', mail?: '', twitter?: '', instagram?: '', telefono?: '', biografia?: '', organizacion?: '', password?: '', facebook?: '', linkedin?: '', inscripcion?: '', crea_reuniones?: '', inscrito_reuniones?: '', mostrar_lista_asistentes?: '',
    clavecongreso?: '', dispositivo?: '', imagen?: ''
  } = {};

  constructor(private sqlite: SQLite, public patrocinadoresprovider: PatrocinadoresProvider, public toastCtrl: ToastController, public chat: ChatProvider, public popoverCtrl: PopoverController, public asistenteProvider: AsistentesProvider, public menuCtrl: MenuController, private theInAppBrowser: InAppBrowser, public notificacionesProvider: NotificacionesProvider, public push: Push, public menuProvider: MenuProvider, public modalCtrl: ModalController, public ponentesProvider: PonentesProvider, public programaProvider: ProgramaProvider, public imagenes: ImagenesProvider, private network: Network, public congresosProvider: CongresosProvider, public loginProvider: LoginProvider, public alertCtrl: AlertController, public platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public events: Events, public global: GlobalProvider, private translateService: TranslateService) {
    //{ titulo: 'PRESENTACION', icono: 'ios-information-circle-outline', opcion: '1' },
    //GENERO TOKEN
    // alert('2');
    this.isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    // Blink engine detection

    this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari']);

    this.loginProvider.token().subscribe(data => {
      this.global.token = data[0].token;

    });

    var valores = this.getGET();
    if (valores) {
      console.log('viene');
      console.log(document.referrer);

      //alert('hacargado');

      // hacemos un bucle para pasar por cada indice del array de valores
      for (var index in valores) {
        if (document.referrer == "https://app.tactilevents.com/previa/?id=" + index) {
          //  if (document.referrer == "https://www.tactilevents.com/app/?id=" + index) {
          this.tipo = 'previa';
        } else {
          this.tipo = '';
        }
        this.congresosProvider.devuelvecongresonombre(index).subscribe(data => {
          var congresote = data[0];
          // alert(congresote.clave);
          //  this.global.aplicacion=valores[index];
          this.global.aplicacion = congresote.clave;
          this.global.bbdd = this.global.aplicacion + this.global.bbdd;
          window.localStorage.clear();
          this.proceso_inicio(statusBar, splashScreen);
          // no se ha recibido ningun parametro por GET
          this.global.carga_inicial = 1;
        });


      }
    } else {
      this.global.carga_inicial = 1;
      this.proceso_inicio(statusBar, splashScreen);
      // no se ha recibido ningun parametro por GET
      //alert("<br>No se ha recibido ningún parámetro");
    }



  }

  proceso_inicio(statusBar, splashScreen) {
  
    this.global.listamenu = [
      { titulo: 'PONENTES', icono: 'ios-people-outline', opcion: '2' }, { titulo: 'PROGRAMA', icono: 'ios-calendar-outline', opcion: '3' },
      { titulo: 'DOCUMENTOS', icono: 'ios-document-outline', opcion: '4' }, { titulo: 'GRUPO DE LINKS', icono: 'ios-link-outline', opcion: '5' }
      , { titulo: 'ENCUESTAS', icono: 'ios-help-outline', opcion: '17' }, { titulo: 'VOTACIONES', icono: 'ios-play-outline', opcion: '7' }, { titulo: 'PATROCINADORES', icono: 'ios-card-outline', opcion: '8' },
      { titulo: 'NOTIFICACIONES', icono: 'ios-alert-outline', opcion: '9' }, { titulo: 'ASISTENTES', icono: 'ios-alert-outline', opcion: '11' }, { titulo: 'REUNIONES', icono: 'ios-alert-outline', opcion: '12' }, { titulo: 'SALAS', icono: 'ios-key-outline', opcion: '13' }
      , { titulo: 'COMENTARIOS', icono: 'ios-key-outline', opcion: '20' }];



    //TEMA
    this.global.getActiveTheme().subscribe(val => this.selectedTheme = val);
    //RECUPERO VARIABLE BACKOFFICE
    this.esbackoffice = this.global.esbackoffice;
    // alert('3');
    this.events.subscribe('user:created', (user, time) => {
      this.login_reg.email = this.global.ficha_usuario['email'];
    });
    //alert('4');
    this.platform.ready().then(() => {
      //CARGAMOS IDIOMA ****************REVISAR
      this.translateService.setDefaultLang('es');
      this.translateService.use('es');
      statusBar.styleDefault();
      //SI ES ANDROID O IOS
      //  if ((this.platform.is('android') || this.platform.is('ios')) && this.esbackoffice != true) {

      //COMPRUEBO SI NO ES BACKOFFICE
      if (this.esbackoffice != true) {
        // alert('5');
        this.oculta_screen = splashScreen;
        //GUID ALMACENADO COMO TEMPORAL
        if (localStorage.getItem('guidtemp')) {
          var guidtemp = localStorage.getItem('guidtemp').replace("\"", "");
          this.global.guid = guidtemp.replace("\"", "");
        }
        //alert('6');
        //MENU GUARDADO TEMPORAL
        this.menuguardado = localStorage.getItem('menutemp');
        if (this.menuguardado != null) {
          this.global.menuglobal = JSON.parse(this.menuguardado);
          console.log('MENU GUARDADO TEMPORAL');
          console.log(this.global.menuglobal);
        }
        //patrocinadores
        this.patrocinadorguardado = localStorage.getItem('patricinadoresstemp');
        if (this.patrocinadorguardado != null) {
          this.global.patrocinadores = JSON.parse(this.patrocinadorguardado);

        }

        //  alert('7');
        //CONGRESO ALMACENADO TEMPORAL
        this.guardado = localStorage.getItem('congresotemp');
        console.log('esta giuarddadao');
        console.log(this.guardado);
        if (this.guardado != null) {
          //EN CASO DE TENER CONGRESO ALMACENADO VOY DIRECTO A SU PAGINA 
          //SIGUE EL CODIGO DE FORMA ASINCRONA
          this.global.congresoglobal = JSON.parse(this.guardado);
          console.log('CONGRESO GUARDAccDO TEMPORAL');
          console.log(this.global.congresoglobal);
          //  alert(this.global.congresoglobal.clave);
          this.global.password = this.global.congresoglobal.password;
          this.global.getActiveTheme().subscribe(val => this.selectedTheme = val);
          this.oculta_screen.hide();
          this.translateService.use(this.global.congresoglobal.idioma);
          console.log(this.global.congresoglobal.nombre);
          // alert('en teoria entra');

          this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, activar: 0, temporal: 1, tipo: this.tipo });


        }
        //alert('creo bbddd');
        //LLAMA A CREAR BBDD Y TABLAS
        if (this.platform.is('android') || this.platform.is('ios') || this.isChrome || this.isSafari) {
          //this.conexion_sqlite();
          //this.agrega_chat(178,196);
          //compruebo conexion
          // Network type that browser uses

          this.network.onchange().subscribe(() => {

            switch (this.network.type) {
              case '2g':
                if (this.global.noti_estado_conexion == false) {
                  this.global.noti_estado_conexion = true;
                  let toast = this.toastCtrl.create({
                    message: 'Conexión lenta ',
                    position: 'top',
                    showCloseButton: true,
                    closeButtonText: 'OK',
                    duration: 3000,
                    dismissOnPageChange: true
                  });

                  toast.onDidDismiss(() => {
                    console.log('Dismissed toast');
                  });

                  toast.present();
                }
                /*let prompt2 = this.alertCtrl.create({
                  title: 'Conexión 2g',
                  message: 'Conexión Lenta',
                  cssClass: "messagealert2",
                  buttons: [
                    {
                      text: 'Cancelar',
                      cssClass: "classcancel",
                      handler: data => {
                        console.log('Cancel clicked');
                      }
                    },
                    {
                      text: 'Aceptar',
                      cssClass: "classok",
                      handler: data => {

                      }
                    }
                  ]
                });
                prompt2.present();*/
                break;

            }
          });
          this.network.onDisconnect().subscribe(() => {
            this.global.estado_conexion = false;
            if (this.global.noti_estado_conexion == false) {
              this.global.noti_estado_conexion = true;
              let toast = this.toastCtrl.create({
                message: 'Sin conexión ',
                position: 'top',
                showCloseButton: true,
                duration: 3000,
                closeButtonText: 'OK',
                dismissOnPageChange: true
              });

              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });

              toast.present();
            }

            /* let prompt = this.alertCtrl.create({
               title: 'Sin conexión',
               message: 'La app no funcionara totalmente',
               cssClass: "messagealert2",
               buttons: [
                 {
                   text: 'Cancelar',
                   cssClass: "classcancel",
                   handler: data => {
                     console.log('Cancel clicked');
                   }
                 },
                 {
                   text: 'Aceptar',
                   cssClass: "classok",
                   handler: data => {
 
                   }
                 }
               ]
             });
             prompt.present();*/
          });
          this.network.onConnect().subscribe(() => {
            this.global.estado_conexion = true;
            switch (this.network.type) {
              case '2g':
                if (this.global.noti_estado_conexion == false) {
                  this.global.noti_estado_conexion = true;
                  let toast = this.toastCtrl.create({
                    message: 'Conexión lenta ',
                    position: 'top',
                    showCloseButton: true,
                    closeButtonText: 'OK',
                    dismissOnPageChange: true
                  });

                  toast.onDidDismiss(() => {
                    console.log('Dismissed toast');
                  });

                  toast.present();
                }
                /*  let prompt2 = this.alertCtrl.create({
                    title: 'Conexión 2g',
                    message: 'Conexión Lenta',
                    cssClass: "messagealert2",
                    buttons: [
                      {
                        text: 'Cancelar',
                        cssClass: "classcancel",
                        handler: data => {
                          console.log('Cancel clicked');
                        }
                      },
                      {
                        text: 'Aceptar',
                        cssClass: "classok",
                        handler: data => {
  
                        }
                      }
                    ]
                  });
                  prompt2.present();*/
                break;

            }

            // alert(this.network.type);
          });
          //Variable para ocultal el screen inicial
          //CONSULTAS SQLITE
          //    alert('consulta sql');
          this.conexion_sqlite().then((x) => {
            this.consulta_sqlite();
          })
        } else {
          this.consulta_sin_sqlite();
        }
        this.congresosProvider.devuelveversion().subscribe(data => {
          //    alert('resultado1');
          //si hay congreso
          if (data.length > 0 && data[0].version > this.global.version_app && this.global.espwa==false) {
            console.log(data[0].version);
            let alert = this.alertCtrl.create({
              title: 'ACTUALIZACIÓN APP',
              cssClass: "messagealert2",
              subTitle: "Nueva actualización disponible",
              message: "<img src='assets/imgs/logo_fondo_menus.jpg'>",
              buttons: [
               
                {
                  text: 'Actualizar',
                  handler: () => {
                    if (this.platform.is('android')){
                      window.open(data[0].urlandroid, '_system', 'location=yes');
                   // this.theInAppBrowser.create(data[0].urlandroid, '_blank', 'location=true');
                    }else if( this.platform.is('ios')){
                      window.open(data[0].urlios, '_system', 'location=yes');
                  //    this.theInAppBrowser.create(data[0].urlios, '_blank', 'location=true');
                    }
                  }
                }
              ]
            });
        
            alert.present();
          }
        });


      } else {
        //SI ES BACKOFFICE VOY A LA PAGINA DE LOGIN

        splashScreen.hide();
        //this.rootPage = 'page-login';
        this.nav.setRoot ('page-login');
      }

    });
  }

  getGET() {
    // capturamos la url
    var loc = document.location.href;
    // si existe el interrogante
    //alert(loc);
    if (loc.indexOf('?') > 0) {
      // cogemos la parte de la url que hay despues del interrogante
      var getString = loc.split('?')[1];
      // obtenemos un array con cada clave=valor
      var GET = getString.split('&');
      var get = {};

      // recorremos todo el array de valores
      for (var i = 0, l = GET.length; i < l; i++) {
        var tmp = GET[i].split('#');
        get[tmp[0]] = (decodeURI(tmp[1]));
      }
      return get;
    }
  }

  //CREA LA BBDD SQLITE 
  conexion_sqlite(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.global.espwa == true) {
        this.db = (window as any).openDatabase(this.global.bbdd, '1.0', 'Test DB', 65535);
        this.db.transaction(function (tx) {
          tx.executeSql('CREATE TABLE IF NOT EXISTS list (id INTEGER PRIMARY KEY AUTOINCREMENT,email TEXT,password TEXT)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS lista_dispositivos (id INTEGER PRIMARY KEY AUTOINCREMENT,guid TEXT)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS list_asistente (id INTEGER PRIMARY KEY AUTOINCREMENT,email TEXT,password TEXT,clavecongreso INTEGER)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS list_chat (id INTEGER PRIMARY KEY AUTOINCREMENT,clavecongreso INTEGER,claveasistenteorigen INTEGER,clavereunion INTEGER)')

        }, function (error) {

          console.log('Transaction ERROR: ' + error.message);
        }, function () {

          resolve('');
          console.log('Populated database OK');
        });
      } else {



        this.db = window.sqlitePlugin.openDatabase({
          name: 'this.global.bbdd',
          location: 'default',
          androidDatabaseProvider: 'system'
        });
        this.db.transaction(function (tx) {
          tx.executeSql('CREATE TABLE IF NOT EXISTS list (id INTEGER PRIMARY KEY AUTOINCREMENT,email TEXT,password TEXT)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS lista_dispositivos (id INTEGER PRIMARY KEY AUTOINCREMENT,guid TEXT)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS list_asistente (id INTEGER PRIMARY KEY AUTOINCREMENT,email TEXT,password TEXT,clavecongreso INTEGER)')
          tx.executeSql('CREATE TABLE IF NOT EXISTS list_chat (id INTEGER PRIMARY KEY AUTOINCREMENT,clavecongreso INTEGER,claveasistenteorigen INTEGER,clavereunion INTEGER)')

        }, function (error) {

          console.log('Transaction ERROR: ' + error.message);
        }, function () {

          resolve('');
          console.log('Populated database OK');
        });


      }
    })

  }


  //CONSULTA USUARIO Y GUID DISPOSITIVO
  consulta_sqlite() {
    //LLAMA getLists para recuperar el mail y password de sqlite
    this.lista_login().then((x) => {
      //llamo al webservice login

      this.loginProvider.login(this.login_reg).subscribe(
        (data) => {
          // si devuelve datos los alamaceno en global
          if (data.length > 0) {
            this.loginProvider.isLoggedIn = true;
            localStorage.setItem('user', JSON.stringify(data[0]));
            this.events.publish('user:created', JSON.stringify(data[0]), Date.now());
            this.global.ficha_usuario = data[0];
            this.global.usuario = data[0].clave;
          }
        }
      )
    });

    //////////////////////////////
    //CONSULTA SI HAY GUID DE DISPOSITIVO EN LA BBDD SQLITE
    this.lista_dispositivos().then((x) => {
      ///////////////////////////////////////////
      //Si tiene guid
      if (this.global.guid != "") {
        /***** */
        //     alert('si guid');
        //   alert(this.global.guid);
        this.congresosProvider.registrodispositivo(this.global.guid).subscribe(data => {
        });
        //   alert('reg');
        //******PENDIENTE ALTA NOTIFICACIONES***** */
        if (this.platform.is('android') || this.platform.is('ios')) {
          //    alert('push nitoic');
          if (this.global.espwa == false) {
            this.initPushNotification(this.global.guid);
          }
          //  
        }
        this.global.getActiveTheme().subscribe(val => this.selectedTheme = val);

        //compruebo que acaba de arrancar la app
        if (this.global.primeracarga == true) {
          //         alert('sigue');
          this.global.primeracarga = false;
          //SI NO TIENE CONEXION
          if (this.network.type == "none") {
            //Recupero el congreso activo alamacenado en localstorage
            /*  var guardado = localStorage.getItem('congresotemp');
              this.oculta_screen.hide();
              this.nav.setRoot('page-paginaprincipal', { congreso: JSON.parse(guardado) });*/
          } else {
            //TENGO CONEXION
            //LLamo al web service para que me devuelva el congreso asociado a ese dispositivo
            //      alert('busca congreso dispositivo');
            this.congresosProvider.congresodispositivo().subscribe(data => {
              //    alert('resultado1');
              //si hay congreso
              if (data.length > 0 && data[0].clave > 0) {
                //cargamos menu 

                this.menuProvider.allfiltro(data[0].clave, 0).subscribe(data => {
                  this.global.menuglobal = data;
                  /* var length = this.global.menuglobal.length;
                   for (var i = 0; i < length; i++) {
                     var im = this.global.menuglobal[i].imagen_boton;
                     if (im != null) {
                       this.imagenes.convierte2(this.global.congresoglobal.clave, this.global.menuglobal[i].imagen_boton, i).subscribe(data => {
                         this.global.menuglobal[data.id].imagen_boton = data.imagen;
 
                         window.localStorage.setItem('menutemp', JSON.stringify(this.global.menuglobal));
                       })
                     }
 
                   };*/
                  //  window.localStorage.setItem('menutemp', JSON.stringify(data));

                })
                var congresote = data[0];
                this.translateService.use(congresote.idioma);
                ///              alert('compruebo imag');
                //this.global.congresoglobal=data[0];
                //si tiene imagen la codifico a b64

                if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {
                  //          alert('img1');
                  this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
                    congresote.imgcabecera = data.imagen;
                    // this.oculta_screen.hide();
                    //voy a la pagina del congreso
                    // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
                    if (congresote.imgpresentacion) {
                      this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                        congresote.imgpresentacion = data.imagen;
                        this.oculta_screen.hide();
                        //voy a la pagina del congreso
                        window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                        this.global.congresoglobal = congresote;
                        if (this.guardado == null) {
                          this.global.password = this.global.congresoglobal.password;

                          this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                        }



                      })
                    } else {
                      //voy a la pagina del congreso
                      this.oculta_screen.hide();
                      window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                      this.global.congresoglobal = congresote;
                      if (this.guardado == null) {
                        this.global.password = this.global.congresoglobal.password;

                        this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                      }

                    }

                  })

                } else if (congresote.imgpresentacion) {
                  //  alert('img2');
                  this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                    congresote.imgpresentacion = data.imagen;
                    this.oculta_screen.hide();
                    //voy a la pagina del congreso
                    window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                    this.global.congresoglobal = congresote;
                    if (this.guardado == null) {
                      this.global.password = this.global.congresoglobal.password;

                      this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                    }


                  })
                } else {
                  //      alert('img3');
                  //voy a la pagina del congreso
                  this.oculta_screen.hide();
                  window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                  this.global.congresoglobal = congresote;
                  if (this.guardado == null) {
                    this.global.password = this.global.congresoglobal.password;

                    this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                  }

                }

              } else {
                //  alert('no hay congreso');
                //no tiene congreso voy a la pagina de congresos
                this.oculta_screen.hide();
                this.rootPage = 'page-home';

              }
            });
          }

        }
      } else {
        //GENERO GUID
        // alert('nuevo guid');
        this.global.guid = this.newGuid();
        //AGREGO GUID A BBDD SQLITE
        this.agrega_dispositivo(this.global.guid).then(() => {
          //    alert('almaceno sqlite');
          // Registro el dispositivo
          this.congresosProvider.registrodispositivo(this.global.guid).subscribe(data => {
            if (this.platform.is('android') || this.platform.is('ios')) {
              if (this.global.espwa == false) {
                this.initPushNotification(this.global.guid);
              }
            }
            // this.cargacongresos();
            ////////////APLICACION ESPECIFICA//////////////////////////////////////////////
            if (this.global.aplicacion > 0) {

              this.congresosProvider.altacongresoclave(this.global.aplicacion).subscribe(data => {
                //  this.oculta_screen.hide();
                var congresote = data[0];
                this.translateService.use(congresote.idioma);
                this.menuProvider.allfiltro(data[0].clave, 0).subscribe(data => {
                  //        alert('resultado menu');
                  this.global.menuglobal = data;


                })
                //si tiene imagen la codifico a b64
                //var congresote = this.formateaimagenes( data[0]);

                if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {

                  this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
                    congresote.imgcabecera = data.imagen;
                    // this.oculta_screen.hide();
                    //voy a la pagina del congreso
                    // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
                    if (congresote.imgpresentacion) {
                      this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                        congresote.imgpresentacion = data.imagen;
                        this.oculta_screen.hide();
                        //voy a la pagina del congreso
                        this.global.congresoglobal = congresote;
                        this.global.password = this.global.congresoglobal.password;
                        this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                        //return congresote;

                      })
                    } else {
                      this.oculta_screen.hide();
                      //voy a la pagina del congreso
                      this.global.congresoglobal = congresote;
                      this.global.password = this.global.congresoglobal.password;
                      this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                    }

                  })

                } else if (congresote.imgpresentacion) {
                  this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                    congresote.imgpresentacion = data.imagen;
                    this.oculta_screen.hide();
                    this.global.congresoglobal = congresote;
                    //voy a la pagina del congreso
                    this.global.password = this.global.congresoglobal.password;
                    this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });

                  })
                } else {
                  this.oculta_screen.hide();
                  this.global.congresoglobal = congresote;
                  //voy a la pagina del congreso
                  this.global.password = this.global.congresoglobal.password;
                  this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                }
                // this.oculta_screen.hide();
                //voy a la pagina del congreso
                //    this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
              });
            } else {
              //   alert('voy a home');
              this.oculta_screen.hide();
              this.rootPage = 'page-home';
            }

          });
        });

      }

      ////////////////////////////////////////////

    });



  }
  consulta_sin_sqlite() {

    //////////////////////////////

    ///////////////////////////////////////////
    //Si tiene guid
    if (this.global.guid != "") {
      /***** */
      //     alert('si guid');
      //   alert(this.global.guid);
      this.congresosProvider.registrodispositivo(this.global.guid).subscribe(data => {
      });
      //   alert('reg');
      //******PENDIENTE ALTA NOTIFICACIONES***** */
      if (this.platform.is('android') || this.platform.is('ios')) {
        //    alert('push nitoic');
        if (this.global.espwa == false) {
          this.initPushNotification(this.global.guid);
        }
        //  
      }
      this.global.getActiveTheme().subscribe(val => this.selectedTheme = val);

      //compruebo que acaba de arrancar la app
      if (this.global.primeracarga == true) {
        //         alert('sigue');
        this.global.primeracarga = false;
        //SI NO TIENE CONEXION
        if (this.network.type == "none") {
          //Recupero el congreso activo alamacenado en localstorage
          /*  var guardado = localStorage.getItem('congresotemp');
            this.oculta_screen.hide();
            this.nav.setRoot('page-paginaprincipal', { congreso: JSON.parse(guardado) });*/
        } else {
          //TENGO CONEXION
          //LLamo al web service para que me devuelva el congreso asociado a ese dispositivo
          //      alert('busca congreso dispositivo');
          this.congresosProvider.congresodispositivo().subscribe(data => {
            //    alert('resultado1');
            //si hay congreso
            if (data.length > 0 && data[0].clave > 0) {
              //cargamos menu 

              this.menuProvider.allfiltro(data[0].clave, 0).subscribe(data => {
                this.global.menuglobal = data;
                /* var length = this.global.menuglobal.length;
                 for (var i = 0; i < length; i++) {
                   var im = this.global.menuglobal[i].imagen_boton;
                   if (im != null) {
                     this.imagenes.convierte2(this.global.congresoglobal.clave, this.global.menuglobal[i].imagen_boton, i).subscribe(data => {
                       this.global.menuglobal[data.id].imagen_boton = data.imagen;
 
                       window.localStorage.setItem('menutemp', JSON.stringify(this.global.menuglobal));
                     })
                   }
 
                 };*/

              })
              var congresote = data[0];
              this.translateService.use(congresote.idioma);
              ///              alert('compruebo imag');
              //this.global.congresoglobal=data[0];
              //si tiene imagen la codifico a b64

              if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {
                //          alert('img1');
                this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
                  congresote.imgcabecera = data.imagen;
                  // this.oculta_screen.hide();
                  //voy a la pagina del congreso
                  // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
                  if (congresote.imgpresentacion) {
                    this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                      congresote.imgpresentacion = data.imagen;
                      this.oculta_screen.hide();
                      //voy a la pagina del congreso
                      window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                      this.global.congresoglobal = congresote;
                      if (this.guardado == null) {
                        this.global.password = this.global.congresoglobal.password;

                        this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                      }



                    })
                  } else {
                    //voy a la pagina del congreso
                    this.oculta_screen.hide();
                    window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                    this.global.congresoglobal = congresote;
                    if (this.guardado == null) {
                      this.global.password = this.global.congresoglobal.password;

                      this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                    }

                  }

                })

              } else if (congresote.imgpresentacion) {
                //  alert('img2');
                this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                  congresote.imgpresentacion = data.imagen;
                  this.oculta_screen.hide();
                  //voy a la pagina del congreso
                  window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                  this.global.congresoglobal = congresote;
                  if (this.guardado == null) {
                    this.global.password = this.global.congresoglobal.password;

                    this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                  }


                })
              } else {
                //      alert('img3');
                //voy a la pagina del congreso
                this.oculta_screen.hide();
                window.localStorage.setItem('congresotemp', JSON.stringify(congresote));
                this.global.congresoglobal = congresote;
                if (this.guardado == null) {
                  this.global.password = this.global.congresoglobal.password;

                  this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                }

              }

            } else {
              //  alert('no hay congreso');
              //no tiene congreso voy a la pagina de congresos
              this.oculta_screen.hide();
              this.rootPage = 'page-home';

            }
          });
        }

      }
    } else {
      //GENERO GUID
      // alert('nuevo guid');
      this.global.guid = this.newGuid();
      //    alert('almaceno sqlite');
      // Registro el dispositivo
      this.congresosProvider.registrodispositivo(this.global.guid).subscribe(data => {
        if (this.platform.is('android') || this.platform.is('ios')) {
          if (this.global.espwa == false) {
            this.initPushNotification(this.global.guid);
          }
        }
        // this.cargacongresos();
        ////////////APLICACION ESPECIFICA//////////////////////////////////////////////
        if (this.global.aplicacion > 0) {

          this.congresosProvider.altacongresoclave(this.global.aplicacion).subscribe(data => {
            //  this.oculta_screen.hide();
            var congresote = data[0];
            this.translateService.use(congresote.idioma);
            this.menuProvider.allfiltro(data[0].clave, 0).subscribe(data => {
              //        alert('resultado menu');
              this.global.menuglobal = data;


            })
            //si tiene imagen la codifico a b64
            //var congresote = this.formateaimagenes( data[0]);

            if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {

              this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
                congresote.imgcabecera = data.imagen;
                // this.oculta_screen.hide();
                //voy a la pagina del congreso
                // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
                if (congresote.imgpresentacion) {
                  this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                    congresote.imgpresentacion = data.imagen;
                    this.oculta_screen.hide();
                    //voy a la pagina del congreso
                    this.global.congresoglobal = congresote;
                    this.global.password = this.global.congresoglobal.password;
                    this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                    //return congresote;

                  })
                } else {
                  this.oculta_screen.hide();
                  //voy a la pagina del congreso
                  this.global.congresoglobal = congresote;
                  this.global.password = this.global.congresoglobal.password;
                  this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
                }

              })

            } else if (congresote.imgpresentacion) {
              this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
                congresote.imgpresentacion = data.imagen;
                this.oculta_screen.hide();
                this.global.congresoglobal = congresote;
                //voy a la pagina del congreso
                this.global.password = this.global.congresoglobal.password;
                this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });

              })
            } else {
              this.oculta_screen.hide();
              this.global.congresoglobal = congresote;
              //voy a la pagina del congreso
              this.global.password = this.global.congresoglobal.password;
              this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal, tipo: this.tipo });
            }
            // this.oculta_screen.hide();
            //voy a la pagina del congreso
            //    this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
          });
        } else {
          //   alert('voy a home');
          this.oculta_screen.hide();
          this.rootPage = 'page-home';
        }

      });


    }

    ////////////////////////////////////////////





  }

  lista_login(): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql("SELECT * FROM list limit 1", [],
          (tx, result) => {
            for (var i = 0; i < result.rows.length; i++) {
              this.login_reg.email = result.rows.item(i)['email'];
              this.login_reg.password = result.rows.item(i)['password'];

            }
            resolve(result);

          },
          (error) => reject(error));
      })
      /*} else {
        this.database.executeSql("SELECT * from list limit 1", [])
          .then((data) => {
            //let lists = [];

            for (let i = 0; i < data.rows.length; i++) {
              //       alert(data.rows.item(i)['email']);
              this.login_reg.email = data.rows.item(i)['email'];
              this.login_reg.password = data.rows.item(i)['password'];

            }

            //return lists;
          })
      }*/


    });
    //return result
  }
  lista_dispositivos(): Promise<any> {
    return new Promise((resolve, reject) => {
      //  if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql("SELECT * FROM lista_dispositivos limit 1", [],
          (tx, result) => {
            for (var i = 0; i < result.rows.length; i++) {
              this.global.guid = result.rows.item(i)['guid'];
              window.localStorage.setItem('guidtemp', JSON.stringify(result.rows.item(i)['guid']));

            }
            resolve(result);

          },
          (error) => reject(error));
      })
      /*  } else {
          this.database.executeSql("SELECT * FROM lista_dispositivos limit 1", [])
            .then((data) => {
              //let lists = [];
  
              for (let i = 0; i < data.rows.length; i++) {
                //       alert(data.rows.item(i)['email']);
                this.global.guid = data.rows.item(i)['guid'];
                window.localStorage.setItem('guidtemp', JSON.stringify(data.rows.item(i)['guid']));
  
  
              }
  
              //return lists;
            })
        }*/
    });

    //return result
  }
  agrega_dispositivo(nuevoguid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      //  if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql(`INSERT INTO lista_dispositivos(guid) VALUES ('${nuevoguid}');`, [],
          (tx, result) => {

            resolve(result);

          },
          (error) => reject(error));
      })
      /* } else {
         this.database.executeSql(`INSERT INTO lista_dispositivos(guid) VALUES ('${nuevoguid}');`, []).then((result) => {
           resolve(result);
         })
       }*/
    });
    //return result
  }
  //BORRA EL USUARIO DE SQLITE
  eliminaLogin(): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql(`DELETE FROM list WHERE id>0;`, [],
          (tx, result) => {

            resolve(result);

          },
          (error) => reject(error));
      })
      /*  } else {
          this.database.executeSql(`DELETE FROM list WHERE id>0;`, []).then((result) => {
            resolve(result);
          })
        }*/
    });

  }
  eliminaLoginAsistente(): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql(`DELETE FROM list_asistente WHERE clavecongreso='${this.global.ficha_asistente.clavecongreso}' and email='${this.global.ficha_asistente.mail}';`, [],
          (tx, result) => {

            resolve(result);

          },
          (error) => reject(error));
      })
      /* } else {
         this.database.executeSql(`DELETE FROM list_asistente WHERE clavecongreso='${this.global.ficha_asistente.clavecongreso}' and email='${this.global.ficha_asistente.mail}';`, []).then((result) => {
           resolve(result);
         })
       }*/
    });

  }
  formateaimagenes(congresote) {
    if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {

      this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
        congresote.imgcabecera = data.imagen;
        // this.oculta_screen.hide();
        //voy a la pagina del congreso
        // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
        if (congresote.imgpresentacion) {
          this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
            congresote.imgpresentacion = data.imagen;
            //this.oculta_screen.hide();
            //voy a la pagina del congreso
            // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
            return congresote;

          })
        } else {
          //voy a la pagina del congreso
          //this.oculta_screen.hide();
          //voy a la pagina del congreso
          // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
          return congresote;
        }

      })

    } else if (congresote.imgpresentacion) {
      this.imagenes.convierte(congresote.clave, congresote.imgpresentacion).subscribe(data => {
        congresote.imgpresentacion = data.imagen;
        //this.oculta_screen.hide();
        //voy a la pagina del congreso
        // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
        return congresote;

      })
    } else {
      //voy a la pagina del congreso
      //this.oculta_screen.hide();
      //voy a la pagina del congreso
      // this.nav.setRoot('page-paginaprincipal', { congreso: congresote });
      return congresote;
    }
  }
  login() {
    if (this.esbackoffice) {
      this.nav.setRoot('page-login');
    } else {
      this.nav.push('page-login');
    }


  }
  login_asistente() {
    if (this.esbackoffice) {
      //   this.nav.setRoot('page-login');
    } else {
      this.nav.push('page-login-asistente');
    }


  }
  pdatos() {
    // window.open('https://www.digitevents.com/SERAU2019/politica_privacidad.php', '_system', 'location=yes');
    window.open('https://www.tactilevents.com/politica-privacidad/', '_system', 'location=yes');
    //  this.theInAppBrowser.create('https://www.tactilevents.com/politica_privacidad.php', '_blank', 'location=true');


  }
  aviso() {
    window.open('https://www.tactilevents.com/aviso-legal/', '_system', 'location=yes');
    //  this.theInAppBrowser.create('https://www.tactilevents.com/nota_legal.php', '_blank', 'location=true');

    // window.open('https://www.digitevents.com/SERAU2019/nota_legal.php', '_system', 'location=yes');
  }

  mis_congresos() {
    window.localStorage.clear();
    this.global.congresoglobal = {};
    this.nav.setRoot('page-home');

  }
  mis_datos() {
    let myModal = this.modalCtrl.create('page-misdatos', { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
      if (data) {
      }
    });


  }
  cambioIdioma(selectedValue) {

    this.translateService.use(selectedValue);
  }

  logout() {

    let alert = this.alertCtrl.create({
      title: '¿DESEA DESLOGEARSE?',
      cssClass: "messagealert2",
      message: '',
      buttons: [
        {
          text: 'CANCELAR',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'ACEPTAR',
          handler: () => {
            this.global.ficha_usuario = '';
            this.global.usuario = 0;

            //this.nav.push('page-login');
            if (this.esbackoffice) {
              this.nav.setRoot('page-login');
            } else {
              this.eliminaLogin().then((x) => {
                if (this.global.aplicacion == 0) {
                  this.mis_congresos();
                } else {

                }

                //this.nav.push('page-login');
              });
            }


          }
        }
      ]
    });

    alert.present();
  }
  logout_asistente() {

    let alert = this.alertCtrl.create({
      title: '¿DESEA DESLOGEARSE?',
      cssClass: "messagealert2",
      message: '',
      buttons: [
        {
          text: 'CANCELAR',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'ACEPTAR',
          handler: () => {
            this.global.ficha_usuario = '';
            this.global.usuario = 0;

            //this.nav.push('page-login');
            if (this.esbackoffice) {
              this.nav.setRoot('page-login');
            } else {
              this.eliminaLoginAsistente().then((x) => {
                this.asistenteProvider.logout(this.global.ficha_asistente).subscribe(
                  (data) => {
                    this.global.ficha_asistente.cargo = '';
                    this.global.ficha_asistente.clave = '';
                    this.global.ficha_asistente.clavecongreso = '';
                    this.global.ficha_asistente.empresa = '';
                    this.global.ficha_asistente.mail = '';
                    this.global.ficha_asistente.nombre = '';
                    this.global.ficha_asistente.password = '';


                  }
                )
                //this.nav.push('page-login');
              });
            }


          }
        }
      ]
    });

    alert.present();
  }
  baja() {
    this.eliminaDispositivo();

  }

  eliminaDispositivo() {
    /* return this.isReady()
       .then(() => {
         return this.database.executeSql("DROP TABLE IF EXISTS lista_dispositivos", []).then((result) => {
           this.nav.setRoot('page-home');
         })
       })*/
  }

  private isReady() {
    return new Promise((resolve, reject) => {
      //if dbReady is true, resolve
      if (this.dbReady.getValue()) {
        resolve();
      }
      //otherwise, wait to resolve until dbReady returns true
      else {
        this.dbReady.subscribe((ready) => {
          if (ready) {
            resolve();
          }
        });
      }
    })
  }
  //FUNCION DEVUELVE GUID DISPOSITIVO ALMACENADO EN SQLITE
  /** Select Row from Table **/
  selectRow(query, callBack) { // <-- extra param
    var result = [];
    this.db.transaction(function (tx) {
      tx.executeSql(query, [], function (tx, rs) {
        for (var i = 0; i < rs.rows.length; i++) {
          var row = rs.rows.item(i)
          /*result[i] = { id: row['id'],
                        name: row['name']
          }*/
        }

        callBack(result); // <-- new bit here
      });
    });
  }

  /*lista_dispositivos() {

   return this.db.transaction(function (tx) {
     tx.executeSql("SELECT * FROM lista_dispositivos limit 1", [], function (tx, results) {
       /*   for (var i = 0; i < results.rows.length; i++) {
             this.global.guid = results.rows.item(i)['guid'];           
            window.localStorage.setItem('guidtemp', JSON.stringify(results.rows.item(i)['guid']));
           
         

     })
   });




    return this.isReady()
       .then(() => {
         return this.database.executeSql("SELECT * from lista_dispositivos", [])
           .then((data) => {
 
             for (let i = 0; i < data.rows.length; i++) {
 
               this.global.guid = data.rows.item(i)['guid'];
               window.localStorage.setItem('guidtemp', JSON.stringify(data.rows.item(i)['guid']));
             }
 
           })
       })DD
 }*/
  //DEVUELVE USUARIO ALMACENADO EN SQLITE
  getLists() {
    /*
        return this.isReady()
          .then(() => {
            return this.database.executeSql("SELECT * from list", [])
              .then((data) => {
                //let lists = [];
                // alert('bbb');
                for (let i = 0; i < data.rows.length; i++) {
                  //   alert(data.rows.item(i)['id']);
    
                  this.login_reg.email = data.rows.item(i)['email'];
                  this.login_reg.password = data.rows.item(i)['password'];
    
                }
    
                //return lists;
              })
          })*/
  }

  agrega_dispositivob(nuevoguid: string) {
    //   alert('consulta agerega');
    return this.db.transaction(function (tx) {
      tx.executeSql(`INSERT INTO lista_dispositivos(guid) VALUES ('${nuevoguid}');`)

    });
    /*  return this.isReady()
        .then(() => {
          return this.database.executeSql(`INSERT INTO lista_dispositivos(guid) VALUES ('${nuevoguid}');`, []).then((result) => {
            if (result.insertId) {
              this.global.guid = nuevoguid;
            }
          })
        });*/
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }



  menu(act) {
    var opcion = act.opcion;
    if (opcion == 1) {
      this.paginacongreso();
    } else if (opcion == 2) {
      this.cargaponentes(act);

    } else if (opcion == 3) {
      this.cargaprograma(act);

    } else if (opcion == 4) {
      this.paginadocumentos(act);
    } else if (opcion == 5) {
      this.paginalinks(act);
    } else if (opcion == 17) {
      this.paginaencuesta(act);
    } else if (opcion == 7) {
      this.paginapreguntas(act);
    } else if (opcion == 8) {
      this.paginapatrocinadores(act);
    } else if (opcion == 9) {
      this.paginanotificaciones(act);
    } else if (opcion == 11) {
      this.paginaasistentes(act);
    } else if (opcion == 12) {
      this.paginareuniones(act);
    } else if (opcion == 13) {
      this.paginasalas(act);
    
  } else if (opcion == 20) {
    this.paginacomentarios(act);
  }
  }
  menu2(act) {
    var opcion = act.opcion;
    if (opcion == 1) {
      this.paginacongreso2();
    } else if (opcion == 2) {
      this.cargaponentes2(act);

      // this.paginaponentes2(act);
    } else if (opcion == 3) {
      this.cargaprograma2(act);
      //  this.paginaprograma2(act);
    } else if (opcion == 4) {
      this.paginadocumentos2(act);
    } else if (opcion == 5) {
      this.paginalinks2(act);
    } else if (opcion == 17) {
      this.paginaencuesta2(act);
    } else if (opcion == 7) {
      this.paginapreguntas2(act);
    } else if (opcion == 8) {
      this.paginapatrocinadores2(act);
    } else if (opcion == 9) {
      this.paginanotificaciones2(act);
    } else if (opcion == 10) {
      this.paginapanel2();
    } else if (opcion == 11) {
      this.paginaasistentes2(act);
    } else if (opcion == 12) {
      this.paginareuniones2(act);
    } else if (opcion == 13) {
      this.paginasalas2(act);
    } else if (opcion == 20) {
      this.paginacomentarios2(act);
    }
  }

  /*****************
   * 
   * 
   * 
   * 
   */
  paginapanel2() {
    if (this.esbackoffice != true) {
      this.nav.push('page-panel', { 'item': this.global.congresoglobal, congreso: this.global.congresoglobal });
    } else {
      this.nav.setRoot('page-panel', { 'item': this.global.congresoglobal, congreso: this.global.congresoglobal });
    }

  }

  paginacongreso2() {

    let myModal = this.modalCtrl.create('page-congreso', { 'congresoactivo': this.global.congresoglobal }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
    });
  }

  paginaponentes2(act) {
    this.nav.setRoot('page-ponentes', { congresoactivo: this.global.congresoglobal, ponentes: this.misponentes, menu: act });
  }

  paginaprograma2(act) {
    this.nav.setRoot('page-programa', { congresoactivo: this.global.congresoglobal, programa: this.miprograma, menu: act });
  }

  paginadocumentos2(act) {
    this.nav.setRoot('page-documentos', { congresoactivo: this.global.congresoglobal, etiquetaselect: act.subopcion, menu: act });
  }

  paginalinks2(act) {
    this.nav.setRoot('page-links', { congresoactivo: this.global.congresoglobal, menu: act });
  }

  paginaencuesta2(act) {
    this.nav.setRoot('page-encuestacab', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginanotificaciones2(act) {
    this.nav.setRoot('page-notificaciones', { congresoactivo: this.global.congresoglobal, menu: act });
  }

  paginapatrocinadores2(act) {

    this.nav.setRoot('page-patrocinadores', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginaasistentes2(act) {

    this.nav.setRoot('page-asistentes', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginareuniones2(act) {

    this.nav.setRoot('page-reuniones', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginasalas2(act) {

    this.nav.setRoot('page-salas', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginacomentarios2(act) {

    this.nav.setRoot('page-comentarios', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginapreguntas2(act) {
    this.nav.setRoot('page-preguntas', { congresoactivo: this.global.congresoglobal, menu: act });
  }
  paginamenu2() {
    this.nav.setRoot('page-menu', { congresoactivo: this.global.congresoglobal });
  }
  /***** */



  paginacongreso() {
    let myModal = this.modalCtrl.create(PresentacionEditPage, { 'congresoactivo': this.global.congresomenu }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
      //this.datos_pruebas.pistas.push(data);
      //this.cargaprograma();      
    });
  }

  paginaponentes(act) {
    this.nav.push('page-ponentes', { congresoactivo: this.global.congresomenu, ponentes: this.misponentes, menu: act });

  }


  paginaprograma(act) {
    this.nav.push('page-programa', { congresoactivo: this.global.congresomenu, programa: this.miprograma, menu: act });
  }

  paginadocumentos(act) {
    this.nav.push('page-documentos', { congresoactivo: this.global.congresomenu, menu: act });
  }

  paginalinks(act) {
    this.nav.push('page-links', { congresoactivo: this.global.congresomenu, menu: act });
  }

  paginaencuesta(act) {
    this.nav.push('page-encuestacab', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginanotificaciones(act) {
    this.nav.push('page-notificaciones', { congresoactivo: this.global.congresomenu, menu: act });
  }

  paginapatrocinadores(act) {

    this.nav.push('page-patrocinadores', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginaasistentes(act) {

    this.nav.push('page-asistentes', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginareuniones(act) {

    this.nav.push('page-reuniones', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginasalas(act) {

    this.nav.push('page-salas', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginacomentarios(act) {

    this.nav.push('page-comentarios', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginapreguntas(act) {
    this.nav.push('page-preguntas', { congresoactivo: this.global.congresomenu, menu: act });
  }
  panelcongreso() {
    this.nav.setRoot(PanelPage, { congreso: this.global.congresomenu });
  }
  paginamenu() {
    this.nav.push('page-menu', { congresoactivo: this.global.congresomenu });
  }

  cargaponentes(atc) {
    this.misponentes = this.ponentesProvider.listaponentes;
    this.ponentesProvider.allponentes(this.global.congresoglobal.clave).subscribe(data => {
      this.misponentes = data;
      window.localStorage.setItem('ponentestemp', JSON.stringify(this.misponentes));

      /* var length = this.misponentes.length;
       for (var i = 0; i < length; i++) {
         var im = this.misponentes[i].imagen;
         if (im != null) {
           this.imagenes.convierte2(this.global.congresoglobal.clave, this.misponentes[i].imagen, i).subscribe(data => {
             this.misponentes[data.id].imagen = data.imagen;
 
             window.localStorage.setItem('ponentestemp', JSON.stringify(this.misponentes));
           })
         }
 
       };*/
      this.paginaponentes(atc);


      ////////////////////
    })
  }
  cargaponentes2(atc) {
    this.misponentes = this.ponentesProvider.listaponentes;
    //  alert("entraxxx");
    //  alert(this.global.token);
    this.ponentesProvider.allponentes(this.global.congresoglobal.clave).subscribe(data => {

      this.misponentes = data;
      window.localStorage.setItem('ponentestemp', JSON.stringify(this.misponentes));

      /*  var length = this.misponentes.length;
        //  alert("devuelve ponenete".length);
        for (var i = 0; i < length; i++) {
          var im = this.misponentes[i].imagen;
          if (im != null) {
            this.imagenes.convierte2(this.global.congresoglobal.clave, this.misponentes[i].imagen, i).subscribe(data => {
              this.misponentes[data.id].imagen = data.imagen;
  
              window.localStorage.setItem('ponentestemp', JSON.stringify(this.misponentes));
            })
          }
  
        };*/

      this.paginaponentes2(atc);
      ////////////////////
    })
  }
  cargaprograma(atc) {
    this.programaProvider.all(this.global.congresoglobal.clave).subscribe(programa => {
      this.miprograma = programa;
      this.paginaprograma(atc);
      window.localStorage.setItem('programatemp', JSON.stringify(this.miprograma));

    })
  }
  cargaprograma2(atc) {
    this.programaProvider.all(this.global.congresoglobal.clave).subscribe(programa => {
      this.miprograma = programa;
      this.paginaprograma2(atc);
      window.localStorage.setItem('programatemp', JSON.stringify(this.miprograma));

    })
  }
  licencias() {
    this.nav.setRoot('page-licencias');

  }
  edit_asistente() {
    this.asistente_formateado.clave = this.global.ficha_asistente.clave;
    this.asistente_formateado.cargo = this.global.ficha_asistente.cargo;
    this.asistente_formateado.clavecongreso = this.global.ficha_asistente.clavecongreso;
    this.asistente_formateado.crea_reuniones = this.global.ficha_asistente.crea_reuniones;
    this.asistente_formateado.dispositivo = this.global.ficha_asistente.dispositivo;
    this.asistente_formateado.empresa = this.global.ficha_asistente.empresa;
    this.asistente_formateado.facebook = this.global.ficha_asistente.facebook;
    this.asistente_formateado.twitter = this.global.ficha_asistente.twitter;
    this.asistente_formateado.instagram = this.global.ficha_asistente.instagram;
    this.asistente_formateado.telefono = this.global.ficha_asistente.telefono;
    this.asistente_formateado.biografia = this.global.ficha_asistente.biografia;
    this.asistente_formateado.organizacion = this.global.ficha_asistente.organizacion;
    this.asistente_formateado.inscripcion = this.global.ficha_asistente.inscripcion;
    this.asistente_formateado.inscrito_reuniones = this.global.ficha_asistente.inscrito_reuniones;
    this.asistente_formateado.linkedin = this.global.ficha_asistente.linkedin;
    this.asistente_formateado.mail = this.global.ficha_asistente.mail;
    this.asistente_formateado.mostrar_lista_asistentes = this.global.ficha_asistente.mostrar_lista_asistentes;
    this.asistente_formateado.nombre = this.global.ficha_asistente.nombre;
    this.asistente_formateado.password = this.global.ficha_asistente.password;
    this.asistente_formateado.imagen = this.global.ficha_asistente.imagen;
    let myModal = this.modalCtrl.create('page-asistenteficha-edit', { 'congresoactivo': this.global.congresoglobal, 'asistente': this.global.ficha_asistente }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
      if (data) {
        this.global.ficha_asistente.imagen = data.imagen;
      }
    });

  }
  editarcongreso() {
    console.log(this.global.congresomenu);

    let myModal = this.modalCtrl.create('page-congreso-edit', { 'congresoactivo': this.global.congresomenu, 'accion': 'UPDATE' }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
      if (data) {

        this.global.congresomenu = data;
        if (this.global.congresomenu.imgcabecera) {
          this.imagenes.convierte(this.global.congresomenu.clave, this.global.congresomenu.imgcabecera).subscribe(data => {
            // this.imagenportada = data.imagen;
            this.global.congresomenu.imgcabecera = data.imagen;
          })
        }
        if (this.global.congresomenu.imgcartel) {
          this.imagenes.convierte(this.global.congresomenu.clave, this.global.congresomenu.imgcartel).subscribe(data => {
            this.global.congresomenu.imgcartel = data.imagen;
          })
        }
        if (this.global.congresomenu.imgicono) {
          this.imagenes.convierte(this.global.congresomenu.clave, this.global.congresomenu.imgicono).subscribe(data => {
            this.global.congresomenu.imgicono = data.imagen;
          })
        }
        if (this.global.congresomenu.imgpresentacion) {
          this.imagenes.convierte(this.global.congresomenu.clave, this.global.congresomenu.imgpresentacion).subscribe(data => {

            this.global.congresomenu.imgpresentacion = data.imagen;
          })
        }
        // this.imagenportada = this.global.congresomenu.imgcabecera;
        //this.datos_pruebas.pistas.push(data);
        //this.cargaprograma();      
      }
    });


    //this.navCtrl.push(CongresoEditPage, {congresoactivo: this.congresoactivo});
  }

  initPushNotification(codigoguid) {
    // to check if we have permission

    this.push.hasPermission()
      .then((res: any) => {

        if (res.isEnabled) {
          console.log('We have permission to send push notifications');
        } else {
          console.log('We do not have permission to send push notifications');
        }

      });

    // Create a channel (Android O and above). You'll need to provide the id, description and importance properties.
    this.push.createChannel({
      id: "testchannel1",
      description: "My first test channel",
      // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
      importance: 3
    }).then(() => console.log('Channel created'));

    // Delete a channel (Android O and above)
    this.push.deleteChannel('testchannel1').then(() => console.log('Channel deleted'));

    // Return a list of currently configured channels
    this.push.listChannels().then((channels) => console.log('List of channels', channels))

    // alert('1');
    const options: PushOptions = {
      android: {},
      ios: {
        alert: 'true',
        badge: 'true',
        sound: 'false',
        clearBadge:'true'
      },
      windows: {}


    }

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('registration').subscribe((registration: any) => {
      if (this.platform.is('android')) {
        var tipo = 0;
      } else {
        var tipo = 1;
      }
      this.congresosProvider.registroidnotificacion(codigoguid, registration.registrationId, tipo, this.global.aplicacion, this.global.cod_aplicacion).subscribe(data => {
      });

    });

    /* pushObject.on('registration').subscribe((data: any) => {
     
      
     });*/
    //  alert('3a');
    pushObject.on('notification').subscribe((notification: any) => {

      //  alert(notification['additionalData']['moredata']);
      //  alert(notification['additionalData']['clavecongreso']);
      if (notification['additionalData']['clasenotificacion'] == 0) {
        this.notificacionesProvider.busca_notificacion(notification['additionalData']['moredata']).subscribe(data => {
          // this.notificacion=data[0];
          let popover = this.popoverCtrl.create('page-ficha-notificacion', { 'notificacion': data[0], 'clave_congreso': notification['additionalData']['clavecongreso'] }, { cssClass: 'carga_popup' })
          popover.present();
        });

        this.notificacionesProvider.notificacionrecibida(notification['additionalData']['moredata']).subscribe(data => {
          // this.imagenportada = data.imagen;
          
          if (notification.additionalData.foreground) {
            //NUEVO
            //   alert(1);
            /*   let popover = this.popoverCtrl.create('page-ficha-notificacion',{},{ cssClass: 'carga_popup' })
               popover.present();*/
            //FIN NUEVO
            /*  let fechaActual = new Date(data.fechapublicacion);
              let dia = fechaActual.getDate().toString();
              let mes = (fechaActual.getMonth() + 1).toString();
              let anio = fechaActual.getFullYear().toString();
              let hora = (fechaActual.getHours() < 10 ? '0' : '') + fechaActual.getHours().toString();
              let minutos = (fechaActual.getMinutes() < 10 ? '0' : '') + fechaActual.getMinutes().toString();
    
                 let alert = this.alertCtrl.create();
              alert.setTitle("<p class='fecha'>" + dia + "-" + mes + "-" + anio + " " + hora + ":" + minutos + "  </p>" + data.texto);
              alert.setMessage("<p class='texto'>" + data.texto_largo + "  </p>");
              alert.setCssClass('alertLogCss');
              alert.addButton({
                text: 'Ok',
                handler: () => {
    
                }
              });
    
              alert.present(alert).then(() => {
    
              });*/

          } else {
            // alert(2);
            /* let popover = this.popoverCtrl.create('page-ficha-notificacion',{},{ cssClass: 'carga_popup' })
             popover.present();*/
            /*let fechaActual = new Date(data.fechapublicacion);
            let dia = fechaActual.getDate().toString();
            let mes = (fechaActual.getMonth() + 1).toString();
            let anio = fechaActual.getFullYear().toString();
            let hora = (fechaActual.getHours() < 10 ? '0' : '') + fechaActual.getHours().toString();
            let minutos = (fechaActual.getMinutes() < 10 ? '0' : '') + fechaActual.getMinutes().toString();
              let alert = this.alertCtrl.create();
            alert.setTitle("<p class='fecha'>" + dia + "-" + mes + "-" + anio + " " + hora + ":" + minutos + "  </p>" + data.texto);
            alert.setMessage("<p class='texto'>" + data.texto_largo + "  </p>");
            alert.setCssClass('alertLogCss');
            alert.addButton({
              text: 'Ok',
              handler: () => {
  
              }
            });
  
            alert.present(alert).then(() => {
  
            });*/


          }

        });
        this.notificacionesProvider.lista_notificacionespendientes(this.global.congresoglobal.clave).subscribe(data => {
          this.global.notificacionespendientes = data.total;
        });


        //  alert('4');



      } else {

        //////NUEVO////////
        if (notification['additionalData']['reunion'] > 0) {

          if (notification['additionalData']['reunion'] != this.global.clave_reunion) {
            //   alert(1);
            this.asistenteProvider.datos_asistente(notification['additionalData']['origen']).subscribe(data => {
              var asistente_origen = data[0];

              // alert(asistente_destino[0]['clave']);
              this.agrega_chat_reunion(notification['additionalData']['congreso'], notification['additionalData']['reunion']);
              let toast = this.toastCtrl.create({
                message: 'REUNION:  ' + asistente_origen.nombre + ' ' + notification['message'],
                position: 'bottom',
                showCloseButton: true,
                closeButtonText: 'OK',
                dismissOnPageChange: true
              });

              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });

              toast.present();


            });
          } else {
            // alert(2);
            this.asistenteProvider.datos_asistente(notification['additionalData']['origen']).subscribe(data => {
              var asistente_origen = data[0];
              var fechactual = new Date();
              fechactual.setHours(fechactual.getHours() + 2);
              var fechactualf = fechactual.toISOString().replace(/T|Z|\.\d{3}/g, ' ').trim();
              //alert(this.global.refreschats.length+'-'+this.global.chats.length);

              this.global.refreschats.push({ texto: notification['message'], fecha: fechactualf, claveasistente: asistente_origen.clave, nombre_asistente: asistente_origen.nombre });

              /*this.chat.listachatreunion(notification['additionalData']['congreso'], this.global.clave_reunion).subscribe(data => {

                this.global.chats = data;
               
              })*/
            });
          }

        } else if (notification['additionalData']['destino'] > 0) {
          // alert('individual');
          // alert(this.global.clave_asistente_origen+'-'+notification['additionalData']['destino']);
          // alert(this.global.clave_asistente_destino+'-'+notification['additionalData']['origen']);

          if (this.global.clave_asistente_origen != notification['additionalData']['destino'] || this.global.clave_asistente_destino != notification['additionalData']['origen']) {
            //alert('acumula');
            this.asistenteProvider.datos_asistente(notification['additionalData']['origen']).subscribe(data => {
              var asistente_origen = data[0];

              // alert(asistente_destino[0]['clave']);
              this.asistenteProvider.datos_asistente(notification['additionalData']['destino']).subscribe(data => {
                var asistente_destino = data[0];
                this.agrega_chat(notification['additionalData']['congreso'], asistente_origen.clave);
                let toast = this.toastCtrl.create({
                  message: asistente_origen.nombre + ': ' + notification['message'],
                  duration: 3000,
                  position: 'bottom'
                });

                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });

                toast.present();
                /*let popover = this.popoverCtrl.create('page-notificacion-chat', { 'mensaje': notification['message'], 'asistente_destino': asistente_destino, 'asistente_origen': asistente_origen, 'clavecongreso': notification['additionalData']['congreso'] }, { cssClass: 'carga_popup' })
    
                let ev = {
                  target: {
                    getBoundingClientRect: () => {
                      return {
                        bottom: 0
                      };
                    }
                  }
                };
    
                popover.present({ ev });*/
              });
            });
            ////////FIN NUEVO/////////
          }
          else {
            //  alert('Muestra');
            this.asistenteProvider.datos_asistente(notification['additionalData']['origen']).subscribe(data => {
              var asistente_origen = data[0];

              // alert(asistente_destino[0]['clave']);
              this.asistenteProvider.datos_asistente(notification['additionalData']['destino']).subscribe(data => {
                var asistente_destino = data[0];
                var fechactual = new Date();
                fechactual.setHours(fechactual.getHours() + 2);
                var fechactualf = fechactual.toISOString().replace(/T|Z|\.\d{3}/g, ' ').trim();
                //alert(this.global.refreschats.length+'-'+this.global.chats.length);
                this.global.refreschats.push({ texto: notification['message'], fecha: fechactualf, claveasistente: asistente_origen.clave, nombre_asistente_origen: asistente_origen.nombre });
                //alert(this.global.refreschats.length+'-'+this.global.chats.length);
                /*                this.chat.listachatindividual(0,notification['additionalData']['congreso'], asistente_origen, asistente_destino).subscribe(data => {
                
                              
                                  this.global.chats = data.reverse();
                                  this.global.refreschats = this.global.chats;
                             
                
                
                                })*/
                /*   this.global.listachatindividual(notification['additionalData']['congreso'],asistente_origen,asistente_destino).subscribe(data => {
             
                     this.global.chats = data;
                    
                     
               
                   })*/
                //    this.global.cargachat(notification['additionalData']['congreso'],asistente_origen,asistente_destino);

              });
            });

          }

        }
      }
    });

    pushObject.on('error').subscribe(error =>

      console.log(error)
    );
  }
  agrega_chat(clavecongreso: any, claveasistenteorigen: any): Promise<any> {
    return new Promise((resolve, reject) => {
      //if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql(`INSERT INTO list_chat(clavecongreso,claveasistenteorigen) VALUES ('${clavecongreso}','${claveasistenteorigen}');`, [],
          (tx, result) => {

            resolve(result);

          },
          (error) => reject(error));
      })
      /*} else {
        this.database.executeSql(`INSERT INTO list_chat(clavecongreso,claveasistenteorigen) VALUES ('${clavecongreso}','${claveasistenteorigen}');`, []).then((result) => {
          resolve(result);
        })
      }*/

    });
    //return result
  }
  agrega_chat_reunion(clavecongreso: any, clavereunion: any): Promise<any> {

    return new Promise((resolve, reject) => {
      // if (this.global.espwa == true) {
      this.db.transaction((tx) => {
        tx.executeSql(`INSERT INTO list_chat(clavecongreso,clavereunion) VALUES ('${clavecongreso}','${clavereunion}');`, [],
          (tx, result) => {

            resolve(result);

          },
          (error) => reject(error));
      })
      /* } else {
         this.database.executeSql(`INSERT INTO list_chat(clavecongreso,clavereunion) VALUES ('${clavecongreso}','${clavereunion}');`, []).then((result) => {
           resolve(result);
         })
       }*/
    });
    //return result
  }
  openPage() {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario

    if (this.selectedMenu) {
      this.selectedMenu = 0;
    } else {
      this.selectedMenu = 1;
    }

  }
  despliega_congreso() {
    this.global.usuario_desplegado = 0;
    if (this.congreso_desplegado == 0) {
      this.congreso_desplegado = 1;
    } else {
      this.congreso_desplegado = 0;
    }
  }
  despliega_usuario() {
    this.congreso_desplegado = 0;
    if (this.global.usuario_desplegado == 0) {
      this.global.usuario_desplegado = 1;
    } else {
      this.global.usuario_desplegado = 0;
    }
  }
  despliega_datos() {
    if (this.datos_desplegado == 0) {
      this.datos_desplegado = 1;
    } else {
      this.datos_desplegado = 0;
    }
  }
  chat_pendiente() {
    this.nav.push('page-lista-chats', { congresoactivo: this.global.congresoglobal });
  }

  refresca_congreso() {
    var varcongreso = this.global.congresoglobal;
    this.global.numero_carga = 1;
    this.global.numero_total = 100;
    this.global.titulo_carga = "Abriendo congreso";
    // let popover = this.popoverCtrl.create('page-progreso',{},{ cssClass: 'carga_popup' })
    //this.global.popover_abierto = true;
    //alberto
    this.global.popover.present();


    //  loader.present();
    this.congresosProvider.size_congreso(varcongreso.clave).subscribe(data => {
      //this.ircongreso(congresote);
    });
    this.congresosProvider.congresoseleccionado(varcongreso).subscribe(data => {
      ///////////////////////////////////////////////
      this.global.numero_carga = 5;

      //  this.oculta_screen.hide();
      var congresote = varcongreso;
      this.menuProvider.allfiltro(varcongreso.clave, 0).subscribe(data => {
        this.global.numero_carga = 15;
        this.global.menuglobal = data;
        window.localStorage.setItem('menutemp', JSON.stringify(this.global.menuglobal));
        /* var length = this.global.menuglobal.length;
         for (var i = 0; i < length; i++) {
           var im = this.global.menuglobal[i].imagen_boton;
           if (im != null) {
             this.imagenes.convierte2(this.global.congresoglobal.clave, this.global.menuglobal[i].imagen_boton, i).subscribe(data => {
               this.global.menuglobal[data.id].imagen_boton = data.imagen;
   
               window.localStorage.setItem('menutemp', JSON.stringify(this.global.menuglobal));
             })
           }
   
         };*/
        //  window.localStorage.setItem('menutemp', JSON.stringify(this.global.menuglobal));
        if(this.global.congresoglobal.publicidad == 1){
          this.patrocinadoresprovider.allimagen(varcongreso.clave).subscribe(data => {
            this.global.numero_carga = 25;
            this.global.patrocinadores = data;
            window.localStorage.setItem('patricinadoresstemp', JSON.stringify(this.global.patrocinadores));
            //si tiene imagen la codifico a b64
            //var congresote = this.formateaimagenes( data[0]);
  
            if (congresote.imgcabecera && !congresote.imgcabecera.includes('base')) {
              this.global.numero_carga = 35;
              this.imagenes.convierte(congresote.clave, congresote.imgcabecera).subscribe(data => {
                congresote.imgcabecera = data.imagen;
                this.global.numero_carga = 45;
  
                //voy a la pagina del congreso
                this.global.congresoglobal = congresote;
                this.global.password = this.global.congresoglobal.password;
                this.global.numero_carga = 50;
                // this.global.popover..dismiss();
  
                this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal });
  
                //  }
  
              })
  
            } else {
              this.global.numero_carga = 50;
              this.global.congresoglobal = congresote;
              //voy a la pagina del congreso
              this.global.password = this.global.congresoglobal.password;
  
              this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal });
  
            }
          });
        }else{
          this.global.numero_carga = 50;
          this.global.congresoglobal = congresote;
          //voy a la pagina del congreso
          this.global.password = this.global.congresoglobal.password;

          this.nav.setRoot('page-paginaprincipal', { congreso: this.global.congresoglobal });

        }
        
      })
      ////////////////////////////////////////////
    });



  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts